// extracted by css-extract-rspack-plugin
export default {"sidebarColumn":"ProductFormSidebar_sidebarColumn__brFtY","sidebarTitle":"ProductFormSidebar_sidebarTitle__e448Y","sidebar":"ProductFormSidebar_sidebar___ms7L"};